import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.createtemplate.label",
    defaultMessage: "Create Booking Template",
    description: "Create booking template label",
  },
});
